import React from "react";
import { connect } from "react-redux";

import HeaderLayout from "../../layouts/HeaderLayout";
import ContentLayout from "../../layouts/ContentLayout";
import FooterLayout from "../../layouts/FooterLayout";

// import SearchResult from "../../components/SearchResult";

const mapStateToProps = (state) => ({
  certSearch: state.searchReducer,
});

function Main() {
  const [loading, setLoading] = React.useState(false);

  return (
    <>
      <div className="container">
        <div className="row">
          <HeaderLayout
            loading={loading}
            setLoading={(value) => {
              setLoading(value);
            }}
          />
          <ContentLayout
            loading={loading}
            setLoading={(value) => {
              setLoading(value);
            }}
          />
        </div>
      </div>

      <FooterLayout />
    </>
  );
}

export default connect(mapStateToProps, null)(Main);
